module.exports = __webpack_public_path__ + "media/hayrat_bildirim4_rev_LOW.32a11814.mp4";